export default __webpack_public_path__ + "static/media/717.5ba5faeb.png";